import { Status } from 'civic-champs-shared/api/hooks/fetchRefactoredSchema'
import useFetchRefactored from 'civic-champs-shared/api/hooks/useFetchRefactored'
import { useCallback } from 'react'
import { TableSortByResponse } from 'core/table/interfaces/TablePersistence'

export const useSetTableSortBy = (): [
  (tableName: string, sortOrder: string) => Promise<TableSortByResponse>,
  Status<TableSortByResponse>,
] => {
  const [request, status] = useFetchRefactored<TableSortByResponse>({
    emptyValue: undefined,
  })

  const setTableSortBy = useCallback(
    (tableName, sortOrder) =>
      request({
        method: 'put',
        url: `/user/tables/${tableName}/sort-by`,
        config: {
          body: {
            sortOrder,
          },
        },
      }),
    [request],
  )

  return [setTableSortBy, status]
}

export default useSetTableSortBy
